import { API, handleApiError } from "./utils";

export const getHostResources = async () => {
  try {
    const { data } = await API.get("/system/host-resources");
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getStorageBreakdown = async () => {
  try {
    const { data } = await API.get("/system/storage-breakdown");
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
